<div class="dash-nav dash-nav"
  style="background-color: white;   background: url('assets/bottom-img.png'),url('assets/worldmap.png');background-repeat: no-repeat;background-position:bottom,top;background-size:auto,cover;background-color: white">
  <header style="background: rgba(0, 0, 0, 0.495)">
    <div style="text-align: center;">
      <img src="../../../../assets/logo.png" style="height: 55px;" />
    </div>
  </header>
  <nav class="dash-nav-list" style="margin-top: 40px">
    <a routerLink="/pas/dashboard" class="dash-nav-item" routerLinkActive="active">
      <i class="fa fa-home"></i> Dashboard
    </a>
    <a routerLink="/pas/appointments" class="dash-nav-item" routerLinkActive="active">
      <i class="fa fa-calendar"></i> Appointments
    </a>
    <a routerLink="/pas/Emergency" class="dash-nav-item" routerLinkActive="active">
      <i class="fa fa-calendar"></i> Emergency
    </a>
    <a routerLink="/pas/members" class="dash-nav-item" routerLinkActive="active">
      <i class="fa fa-male"></i> Member
    </a>
    <a routerLink="/pas/test" class="dash-nav-item" routerLinkActive="active">
      <i class="fa fa-flask"></i> Lab-Test
    </a>
    <!-- <a routerLink="/pas/addclinic" class="dash-nav-item" *ngIf="doctype != 'RECEPTIONIST'" routerLinkActive="active">
      <i class="fa fa-plus"></i>Add Clinic
    </a> -->
    <a routerLink="/pas/profile" class="dash-nav-item" routerLinkActive="active" *ngIf="doctype != 'RECEPTIONIST'">
      <i class="fa fa-user-md"></i>Profile
    </a>
    <a (click)="onClickLogout()" style="cursor:pointer" class="dash-nav-item">
      <i class="fa fa-sign-out"></i> Logout
    </a>
  </nav>
  <div style="text-align: center;">
    <p
      style="color:white;font-size: 12px;word-wrap:break-word;text-align: center;position: absolute;bottom:1px;padding:5px">
      © Copyright <b>MAVIN GLOBUS</b><br />
      All Rights Reserved
    </p>
  </div>
</div>